// Libraries
import React, { useEffect, useState } from "react";
import { useObserver } from "mobx-react-lite";
import { useRouter } from "@shoothill/core";
import { runInAction } from "mobx";

// Custom
import { DetailsHeader } from "Globals/Views/DetailsPage/DetailsHeader";
import { ProjectGeneralViewModel } from "../../General/ProjectGeneralViewModel";
import { RDDV2Table } from "./RDDV2Table";

// Styling & Images
import { SHBox } from "../../../../Components/Box";
import { DetailsPage } from "Globals/Views/DetailsPage/DetailsPage.styles";
import { RDDV2ViewModel } from "./RDDV2ViewModel";

export const RDDV2ListView: React.FunctionComponent = () => {
    const router = useRouter();
    let { projectid } = router.match.params as any;
    const [generalViewModel] = useState(() => ProjectGeneralViewModel.Instance);
    const [viewModel] = useState(new RDDV2ViewModel());

    useEffect(() => {
        runInAction(async () => {
            await viewModel.loadRDDV2s(projectid);
        });
        return () => {
            viewModel.clean();
        };
    }, []);

    // Add handler to toggle issue property
    const handleToggleIssue = (id: string) => {
        runInAction(() => {
            const item = viewModel.rddV2ItemViewModels.find((item) => item.id === id);
            if (item) {
                item.toggleIssue();
                // Force array reference change for MobX reactivity
                viewModel.rddV2ItemViewModels.replace([...viewModel.rddV2ItemViewModels]);
            }
        });
    };

    // Compute a key that changes when any issue state changes
    const tableKey = viewModel.getRDDV2Items.map((item) => item.issue).join("-");

    const renderPage = () => {
        return (
            <DetailsPage className="cell-right rcselect">
                <DetailsHeader viewModel={generalViewModel.getHeader} />
                <SHBox style={{ padding: "5px 30px 20px 30px" }}>
                    {viewModel.hasLoaded && (
                        <RDDV2Table
                            key={tableKey}
                            data={viewModel.getRDDV2Items}
                            isLoading={viewModel.IsLoading}
                            handleSearchChange={(searchText: string) => viewModel.handleSearchChange(projectid, searchText)}
                            projectId={projectid}
                            viewModel={viewModel}
                            onToggleIssue={handleToggleIssue}
                        />
                    )}
                </SHBox>
            </DetailsPage>
        );
    };

    return useObserver(() => renderPage());
};
